<div *ngIf="show" class="progress">
  <div class="indeterminate"></div>
</div>
